import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopDevPageSideVideoSide = /*#__PURE__*/ React.memo(()=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopDevPageSideVideoSide'], {
        debug: process.env.NODE_ENV !== 'production',
        format: 'video-nc',
        video: {}
    });
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, ()=>true // never rerender
);
DesktopDevPageSideVideoSide.displayName = 'DesktopDevPageSideVideoSide';
export default DesktopDevPageSideVideoSide;
